import React from "react";
import { Can } from "src/app/services/can";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { NotAllowed } from "../components/not-allowed";
import { InvoicesPage } from "./invoices-page";

export const InvoicesRouter = () => {

    return <>
        {
            Can(UserEntitlementCatalogs.ViewVaultInvoicesInvoiceTab) ? <InvoicesPage /> : <NotAllowed />
        }
    </>
}